import {
  QueryClient,
  QueryClientProvider,
} from "react-query";

import "./App.css";
import Home from "./pages/home";
import Login from "./pages/admin/Login";
import List from "./pages/admin/List";
import Form from "./pages/admin/Form";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const paths = [
  { path: "/", component: Home },

  { path: "/login", component: Login },
  { path: "/list", component: List },
  { path: "/form", component: Form },
  { path: "/dashboard/*", component: Dashboard },
  { path: "/:project_dp_handle", component: Home },
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <Routes>
            {paths.map((p) => (
              <Route key={p.path} path={p.path} element={<p.component />} />
            ))}
          </Routes>
        </QueryClientProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
